import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIClient } from "src/app/core/api-client/contracts/api-client.service";
import { IIDN } from "src/app/shared/models/IIDN";
import { ITenantIDM } from "src/app/shared/models/ITenantIDM";
import { ICountry, IState } from "src/app/shared/models/lookup.model";

export enum OperationTypeIdn { Select = 1, Create = 2 };
@Injectable({
  providedIn: 'root'
})
export class IdnService {
  resource = 'idn';
  constructor(private client: APIClient) { }

  getAllIDNs(): Observable<IIDN[]> {
    return this.client.get<IIDN[]>(`${this.resource}/getallidns`);
  }
  
  getIDNById(id: number): Observable<IIDN> {
    return this.client.get<IIDN>(`${this.resource}/${id}`)
  }
  
  createIDN(idn: IIDN): Observable<IIDN> {
    return this.client.post<IIDN>(`${this.resource}`, idn);
  }
  
  getAllCountry(): Observable<ICountry[]>
  {
    return this.client.get<ICountry[]>(`${this.resource}/getAllCountry`);
  }

  getAllStatesByCountryId(id: number): Observable<IState[]> {
    return this.client.get<IState[]>(`${this.resource}/GetAllStatesByCountryId/${id}`);
  }

  getAllFromIDM(): Observable<ITenantIDM[]> {
    return this.client.get<ITenantIDM[]>(`${this.resource}/getallfromidm`);
  }
}